{
  "fr": {
    "session": {
      "error_internalserver": {
        "goback": "Retour",
        "subtitle": "Oops, une erreur inattendue semble s'être produite.",
        "title": "500"
      },
      "error_notfound": {
        "goback": "Retour",
        "subtitle": "Désolé, la page que vous recherchez est introuvable.",
        "title": "404"
      },
      "expired": {
        "text": "Votre session a expiré pour cause d'inactivité. Pour des raisons de sécurité, vous devez vous connecter à nouveau. \n\nCliquer sur OK pour être redirigé vers l'écran de connexion.",
        "title": "Session expiré"
      },
      "logout_impersonate": {
        "text": "Une action de déconnexion a été déclenchée pendant l'imitation.",
        "title": "Imitation arrêtée"
      },
      "noaccess": {
        "text": "Vous pourriez être concerné par notre dernière <b>mise à jour</b> : <p></p> <ul> <li>&nbsp;</li> <li><b>Les membres de l'équipe et les partenaires</b> ont désormais accès via <b>ziggu.app</b> (au lieu de <i>%company%</i>.ziggu.app)</li> <li>&nbsp;</li> <li><b>Les clients</b> ne sont pas affectés et peuvent toujours accéder à la plateforme via <b><i>%company%</i>.ziggu.app</b> </ul> <p>&nbsp;</p> <p>En cliquant sur OK, vous serez redirigé vers la page appropriée. Pour tout problème, veuillez nous contacter.</p>",
        "title": "Oups.. il semble que vous n'ayez plus accès à cette page."
      }
    }
  }
}
